<template>
  <scout-form
    :is-modified="hasCandidateOtherJob"
    label="送信候補"
  >
    <label class="boss-checkbox">
      <input
        :checked="hasCandidateOtherJob"
        class="boss-input-checkbox"
        type="checkbox"
        data-test="candidate-other-job"
        @change="$emit('update:hasCandidateOtherJob', $event.target.checked)"
      >その他の自社求人で送信候補に入れている会員を除外
    </label>
    <div class="boss-annotation-text">
      ※この自社求人で送信候補に入れている会員はすでに除外されています。
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'

export default {
  components: {
    ScoutForm
  },
  props: {
    hasCandidateOtherJob: {
      required: true,
      type: Boolean
    }
  }
}
</script>
